import React from 'react';
type SectionTitleProps = {
  children: React.ReactNode;
  subtitle?: React.ReactNode;
  underline?: boolean;
  id?: string;
};
export function SectionTitle({
  children,
  subtitle,
  underline = false,
  id
}: SectionTitleProps) {
  return <div className="mx-auto max-w-2xl text-center" data-id="element-245" data-mp="2fvaflh9oayyf">
      <h2 id={id} className="font-display text-[1.75rem] font-extrabold leading-[1.15] tracking-[-0.03em] text-ink md:text-4xl" data-id="element-246" data-mp="2avxj04t02din">
        {children}
      </h2>
      {underline && <span aria-hidden="true" className="mx-auto mt-3 block h-1 w-36 rounded-full bg-gradient-to-r from-[#D8CCF6] to-[#F3B6D0]" data-id="element-247" data-mp="33kcvajkqyhqa" />}
      {subtitle && <p className="mt-4 text-[17px] leading-relaxed text-body" style={{
      fontWeight: "400"
    }} data-id="element-248" data-mp="2ysblr5eyr53y">{subtitle}</p>}
    </div>;
}